import PolicyLayout from "../../components/PolicyLayout/PolicyLayout";
import { COOKIES_POLICY_COPY } from "../../content/localizedPageCopy";
import { useLocale } from "../../contexts/LocaleContext";

export default function CookiesPolicy() {
  const { locale } = useLocale();
  const copy = COOKIES_POLICY_COPY[locale];

  return (
    <PolicyLayout
      badge={copy.badge}
      title={copy.title}
      pageTitle={copy.pageTitle}
      canonicalPath="/cookies-policy"
      description={copy.description}
      summaryTitle={copy.summaryTitle}
      summaryBody={copy.summaryBody}
      sections={copy.sections}
      content={copy.content}
    />
  );
}
